import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { MIGRATION_ASSIST_TABLE_SCHEMA, TransactionMode, } from '@tencent/memoire-core';
import { Command } from './client-msg.interface';
import { NativeEngineDatabase } from './database';
import { OpenDBError, UnSupportError } from './error';
import { ClientProxy } from './client-proxy';
import { KeyUtils } from './utils/key-utils';
import cmp from './utils/cmp';
var NativeEngine = /** @class */ (function () {
    function NativeEngine() {
        this.cmp = cmp;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    NativeEngine.prototype.deleteDB = function (dbName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO implements native db destroy
                return [2 /*return*/];
            });
        });
    };
    NativeEngine.prototype.setAspects = function (engineAspects) {
        this.engineAspects = engineAspects;
        engineAspects.openDB.patch(this, 'openDB');
        engineAspects.deleteDB.patch(this, 'deleteDB');
    };
    NativeEngine.prototype.openDB = function (dbName, schema, version, callback) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var resp, tables, db, transaction;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, ClientProxy.send({
                            command: Command.INIT,
                            dbName: dbName,
                            table: this.getTableInfo(schema),
                        })];
                    case 1:
                        resp = (_e.sent());
                        if (resp.err_msg || resp.err_code) {
                            throw new OpenDBError(dbName + " errCode: " + resp.err_code + ", errMsg: " + resp.err_msg);
                        }
                        return [4 /*yield*/, this.getDBExistTableNames(dbName)];
                    case 2:
                        tables = _e.sent();
                        db = new NativeEngineDatabase(schema, dbName, version !== null && version !== void 0 ? version : 0, tables, (_b = (_a = resp.result) === null || _a === void 0 ? void 0 : _a.supportTransaction) !== null && _b !== void 0 ? _b : false, this.engineAspects);
                        // db has not upgrade or upgrade callback is undefine, return db
                        if (!((_c = resp.result) === null || _c === void 0 ? void 0 : _c.dbSchemaChange) || !(callback === null || callback === void 0 ? void 0 : callback.upgrade)) {
                            return [2 /*return*/, db];
                        }
                        return [4 /*yield*/, db.transaction(tables, TransactionMode.VERSION_CHANGE)];
                    case 3:
                        transaction = (_e.sent());
                        // TODO get real db version
                        (_d = callback === null || callback === void 0 ? void 0 : callback.upgrade) === null || _d === void 0 ? void 0 : _d.call(callback, db, 0, version !== null && version !== void 0 ? version : null, transaction);
                        return [4 /*yield*/, transaction.waitForTransactionDone()];
                    case 4:
                        _e.sent();
                        return [2 /*return*/, db];
                }
            });
        });
    };
    /**
     * native db unsupport get DBNames, so we only get it from migration_assist_table
     * TODO(line) push native db to support this feature
     */
    NativeEngine.prototype.getDBExistTableNames = function (dbName) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var clientResp, existSchemas;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ClientProxy.send({
                            dbName: dbName,
                            command: Command.GET_ALL,
                            tableName: MIGRATION_ASSIST_TABLE_SCHEMA.name,
                        })];
                    case 1:
                        clientResp = _b.sent();
                        // if read migration assist table error or has not data, we should return empty array,
                        // so the migration process can rebuild assist table data
                        if (clientResp.err_code || clientResp.err_msg || !((_a = clientResp.result) === null || _a === void 0 ? void 0 : _a.length)) {
                            return [2 /*return*/, []];
                        }
                        existSchemas = clientResp.result;
                        return [2 /*return*/, __spreadArray(__spreadArray([], __read(existSchemas)), [MIGRATION_ASSIST_TABLE_SCHEMA]).map(function (schema) { return schema.name; })];
                }
            });
        });
    };
    NativeEngine.prototype.getTableInfo = function (schema) {
        if (!schema) {
            return [];
        }
        return schema.collections.map(function (col) {
            var _a;
            if (!((_a = col.key) === null || _a === void 0 ? void 0 : _a.path)) {
                throw new UnSupportError('key autoIncrement');
            }
            var indices = col.indices.map(function (index) {
                if (index.path instanceof Array) {
                    throw new UnSupportError('union index');
                }
                return KeyUtils.getDBKeyFromKeyPath(index.path);
            });
            // support union key, we should add index for each key
            if (col.key.path instanceof Array) {
                col.key.path.forEach(function (key) {
                    indices.push(key);
                });
            }
            return {
                tableName: col.name,
                keyName: KeyUtils.getDBKeyFromKeyPath(col.key.path),
                indexs: __spreadArray([], __read(new Set(indices))),
            };
        });
    };
    return NativeEngine;
}());
export { NativeEngine };
//# sourceMappingURL=engine.js.map